<template>
  <div class="status-message-container" v-show="msg">
    <div class="status-message">
      {{msg}}
    </div>
  </div>
</template>

<script>
import {Events} from '../events'

export default {
  name: 'StatusMessage',
  data: () => ({
    msg: ''
  }),
  created() {
    Events.$on('setStatusMessage', msg => this.msg = msg)
  }
}
</script>

<style lang="scss" scoped>
@use '../styles/variables' as v;

.status-message-container {
  position: fixed;
  top: v.$navbar-height + 10px;
  left: 0;
  width: 100%;
  z-index: 8000;
  pointer-events: none;

  .status-message {
    position: relative;
    width: 250px;
    margin: 0 auto;
    background: saturate(v.$yellow, 20);
    text-align: center;
    color: v.$black;
    font-size: v.$font-size-small;
    padding: 10px;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.5);
  }
}
</style>
